'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function assign(obj, props) {
  for (var key in props) {
    Object.defineProperty(obj, key, {
      value: props[key],
      enumerable: true,
      configurable: true
    });
  }

  return obj;
}

function createError(err, code, props) {
  if (!err || typeof err === 'string') {
    throw new TypeError('Please pass an Error to err-code');
  }

  if (!props) {
    props = {};
  }

  if (_typeof(code) === 'object') {
    props = code;
    code = undefined;
  }

  if (code != null) {
    props.code = code;
  }

  try {
    return assign(err, props);
  } catch (_) {
    props.message = err.message;
    props.stack = err.stack;

    var ErrClass = function ErrClass() {};

    ErrClass.prototype = Object.create(Object.getPrototypeOf(err));
    return assign(new ErrClass(), props);
  }
}

module.exports = createError;


//////////////////
// WEBPACK FOOTER
// ./node_modules/err-code/index.js
// module id = 426
// module chunks = 0